import { fabric } from 'fabric';

export const FONTS = ['Amarante', 'Black Ops One', 'Bree Serif', 'Cantora One', 'Courgette', 'Francois One', 'Grand Hotel', 'Grand Vibes', 'Khand', 'Limelight', 'Lobster', 'Oregano', 'Oswald', 'Playball', 'Rubik One', 'Sacramento', 'Sancreek'];
export const DEFAULT_NEW_TEXT = 'New text';
export const FabricTypeConverter: any = {
	'i-text': 'editText',
	textbox: 'editText',
	'i-image': '',
};
export const TEXT_COLORS = ['#212121', '#FFFFFF', '#DE901C', '#4EDE1C', '#C52A2A', '#2AC5BB', '#522AC5', '#B82AC5'];
export const DEFAULT_COLOR = '#212121';
export const DEFAULT_TEXT_CONFIG = {
	editable: true,
	hasBorders: true,
	// borderColor: 'rgba(255, 255, 255, 1)',
	// borderColor: '#E5DDF6',
	borderColor: '#3f7708',
	borderDashArray: [4, 4],
	padding: 0,
	fontSize: 30,
	fill: DEFAULT_COLOR,
	splitByGrapheme: true,
};
export const DEFAULT_FONT_SIZE = 12;
export const DELETE_IMAGE_STRING =
	'data:image/svg+xml;base64,' +
	btoa(`<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10Z" fill="black"/>
<path d="M2.5 3.5H3.05556H7.5" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.94455 3.5V7C6.94455 7.13261 6.88602 7.25979 6.78183 7.35355C6.67765 7.44732 6.53634 7.5 6.389 7.5H3.61122C3.46388 7.5 3.32257 7.44732 3.21838 7.35355C3.1142 7.25979 3.05566 7.13261 3.05566 7V3.5M3.889 3.5V3C3.889 2.86739 3.94753 2.74021 4.05172 2.64645C4.1559 2.55268 4.29721 2.5 4.44455 2.5H5.55566C5.70301 2.5 5.84431 2.55268 5.9485 2.64645C6.05269 2.74021 6.11122 2.86739 6.11122 3V3.5" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.44434 4.75V6.25" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.55566 4.75V6.25" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`);
export const ROTATE_IMAGE_STRING =
	'data:image/svg+xml;base64,' +
	btoa(`<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10Z" fill="black"/>
<path d="M2.5 2.74072V4.19905H3.88889" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.08102 5.4144C3.23111 5.86171 3.51559 6.24569 3.89159 6.50848C4.26759 6.77127 4.71474 6.89864 5.16567 6.87138C5.61661 6.84413 6.04689 6.66374 6.39169 6.35739C6.7365 6.05104 6.97714 5.63533 7.07736 5.17289C7.17759 4.71045 7.13196 4.22633 6.94736 3.79348C6.76276 3.36064 6.44919 3.00251 6.05389 2.77306C5.6586 2.54361 5.20298 2.45526 4.75571 2.52134C4.30844 2.58741 3.89373 2.80433 3.57407 3.1394L2.5 4.19912" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`);
export const RESIZE_TOP_LEFT_IMAGE_STRING =
	'data:image/svg+xml;base64,' +
	btoa(`<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10Z" fill="black"/>
<g clip-path="url(#clip0_144_2532)">
<path d="M2.75 4.25L2.74992 2.75015L4.24967 2.75007" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.24967 5.75007L7.24975 7.24992L5.75 7.25" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.7499 2.75018L4.49971 4.4999" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.24971 7.2499L5.4999 5.50018" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_144_2532">
<rect width="6.00005" height="5.99967" fill="white" transform="translate(2 8) rotate(-90.0031)"/>
</clipPath>
</defs>
</svg>
`);
export const RESIZE_TOP_RIGHT_IMAGE_STRING =
	'data:image/svg+xml;base64,' +
	btoa(`<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M-2.18557e-07 5C-3.39263e-07 7.76142 2.23858 10 5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 -9.78513e-08 5 -2.18557e-07C2.23858 -3.39263e-07 -9.78513e-08 2.23858 -2.18557e-07 5Z" fill="black"/>
<g clip-path="url(#clip0_144_2532)">
<path d="M5.75 2.75L7.24985 2.74992L7.24993 4.24967" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.24993 7.24967L2.75008 7.24975L2.75 5.75" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.24982 2.7499L5.5001 4.49971" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.7501 7.24971L4.49982 5.4999" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_144_2532">
<rect width="6.00005" height="5.99967" fill="white" transform="translate(2 2)"/>
</clipPath>
</defs>
</svg>
`);
export const RESIZE_HORIZONTAL_IMAGE_STRING =
	'data:image/svg+xml;base64,' +
	btoa(`<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10Z" fill="black"/>
<g clip-path="url(#clip0_527_5819)">
<path d="M6.67578 5.70874L7.56337 4.78093L6.63556 3.89334" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.0047 3.9739L2.11711 4.90172L3.04492 5.78931" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.56384 4.78108L5.44587 4.828" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.11677 4.90173L4.23474 4.85481" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<path d="M5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10Z" fill="black"/>
<g clip-path="url(#clip1_527_5819)">
<path d="M6.67578 5.70874L7.56337 4.78093L6.63556 3.89334" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.0047 3.9739L2.11711 4.90172L3.04492 5.78931" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.56384 4.78108L5.44587 4.828" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.11677 4.90173L4.23474 4.85481" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_527_5819">
<rect width="5.13656" height="5.13656" fill="white" transform="matrix(0.691271 -0.722596 -0.722596 -0.691271 4.9209 8.47241)"/>
</clipPath>
<clipPath id="clip1_527_5819">
<rect width="5.13656" height="5.13656" fill="white" transform="matrix(0.691271 -0.722596 -0.722596 -0.691271 4.9209 8.47241)"/>
</clipPath>
</defs>
</svg>

`);
//                                   LEFT, TOP, dx , dy
export const FAKE_RESTRICTION_AREA: [LEFT: number, TOP: number, dX: number, dY: number] = [2200, 230, 290, 370];
export const RESTRICTION_AREA_BORDER = 3;

export const HideControls = {
	tl: false,
	tr: false,
	bl: false,
	br: false,
	ml: false,
	mt: false,
	mr: false,
	mb: false,
	mtr: false, //True za rotaciju
};
export const HideControlsTextbox = {
	tl: false,
	tr: false,
	bl: false,
	br: false,
	ml: true,
	mt: false,
	mr: true,
	mb: false,
	mtr: true, //True za rotaciju
};

export const renderIcon = () => {
	const img = new Image();
	img.src = DELETE_IMAGE_STRING;

	return (ctx: CanvasRenderingContext2D, left: number, top: number, styleOverride: any, fabricObject: fabric.Object) => {
		const size = 24;
		if (img.complete && size > 0) {
			ctx.save();
			ctx.translate(left, top); // Removed the offset translation
			ctx.drawImage(img, -size / 2, -size / 2, size, size);
			ctx.restore();
		}
	};
};

export const deleteObject = (eventData: MouseEvent, transformData: fabric.Transform, x: number, y: number): boolean => {
	const target = transformData.target;
	const canvas = target?.canvas;
	if (canvas && target) {
		canvas?.remove(target);
		canvas?.requestRenderAll();
		return true;
	}
	return false;
};

export const DELETE_CONTROL = new fabric.Control({
	x: 0,
	y: -0.5,
	offsetY: 0,
	offsetX: 0,
	cursorStyle: 'pointer',
	mouseUpHandler: deleteObject,
	render: renderIcon(),
	touchSizeX: 24,
	touchSizeY: 24,
	sizeX: 24,
	sizeY: 24,
});
export const ROTATE_CONTROL = new fabric.Control({
	x: 0,
	y: -0.5,
	offsetY: -40,
	offsetX: 0,
	cursorStyle: 'crosshair',
	// Create a custom rotation handler that rotates around the object center
	actionHandler: function (eventData, transform, x, y) {
		const target = transform.target;
		if (!target || !target.canvas) return false;

		// Calculate the center point of the object
		const centerPoint = target.getCenterPoint();
		const pointer = target.canvas.getPointer(eventData);

		// Calculate angle from center point to pointer
		const angleRadians = Math.atan2(pointer.y - centerPoint.y, pointer.x - centerPoint.x);
		let angleDegrees = fabric.util.radiansToDegrees(angleRadians);

		// Optional: snap angle to increments (e.g., 15 degrees)
		const snapAngle = 15;
		const snapThreshold = 7.5; // degrees
		const snappedAngle = Math.round(angleDegrees / snapAngle) * snapAngle;

		if (Math.abs(angleDegrees - snappedAngle) < snapThreshold) {
			angleDegrees = snappedAngle;
		}

		// Set the object's angle
		target.angle = angleDegrees;

		return true;
	},
	render: renderIcon(),
	touchSizeX: 24,
	touchSizeY: 24,
	sizeX: 24,
	sizeY: 24,
});

export const customRotationRender = (ctx: any, left: any, top: any, styleOverride: any, fabricObject: any) => {
	const img = new Image();
	img.src = ROTATE_IMAGE_STRING; // Your icon as base64 or path

	const size = 24; // Your desired size

	if (img.complete && size > 0) {
		ctx.save();
		ctx.translate(left, top);
		ctx.drawImage(img, -size / 2, -size / 2, size, size);
		ctx.restore();
	} else {
		// Add this to handle the case when the image isn't loaded yet
		img.onload = () => {
			fabricObject.canvas?.requestRenderAll();
		};
		// Draw a fallback (optional)
		ctx.save();
		ctx.translate(left, top);
		ctx.fillStyle = 'rgba(0,0,0,0.3)';
		ctx.fillRect(-size / 2, -size / 2, size, size);
		ctx.restore();
	}
};
export const customResizeRender = (ctx: any, left: any, top: any, styleOverride: any, fabricObject: any) => {
	const img = new Image();
	img.src = RESIZE_TOP_LEFT_IMAGE_STRING; // Your icon as base64 or path

	const size = 24; // Your desired size

	if (img.complete && size > 0) {
		ctx.save();
		ctx.translate(left, top);
		ctx.drawImage(img, -size / 2, -size / 2, size, size);
		ctx.restore();
	} else {
		// Add this to handle the case when the image isn't loaded yet
		img.onload = () => {
			fabricObject.canvas?.requestRenderAll();
		};
		// Draw a fallback (optional)
		ctx.save();
		ctx.translate(left, top);
		ctx.fillStyle = 'rgba(0,0,0,0.3)';
		ctx.fillRect(-size / 2, -size / 2, size, size);
		ctx.restore();
	}
};
export const customResizeOddRender = (ctx: any, left: any, top: any, styleOverride: any, fabricObject: any) => {
	const img = new Image();
	img.src = RESIZE_TOP_RIGHT_IMAGE_STRING; // Your icon as base64 or path

	const size = 24; // Your desired size

	if (img.complete && size > 0) {
		ctx.save();
		ctx.translate(left, top);
		ctx.drawImage(img, -size / 2, -size / 2, size, size);
		ctx.restore();
	} else {
		// Add this to handle the case when the image isn't loaded yet
		img.onload = () => {
			fabricObject.canvas?.requestRenderAll();
		};
		// Draw a fallback (optional)
		ctx.save();
		ctx.translate(left, top);
		ctx.fillStyle = 'rgba(0,0,0,0.3)';
		ctx.fillRect(-size / 2, -size / 2, size, size);
		ctx.restore();
	}
};
export const customHorizontalRender = (ctx: any, left: any, top: any, styleOverride: any, fabricObject: any) => {
	const img = new Image();
	img.src = RESIZE_HORIZONTAL_IMAGE_STRING; // Your icon as base64 or path

	const size = 24; // Your desired size

	if (img.complete && size > 0) {
		ctx.save();
		ctx.translate(left, top);
		ctx.drawImage(img, -size / 2, -size / 2, size, size);
		ctx.restore();
	} else {
		// Add this to handle the case when the image isn't loaded yet
		img.onload = () => {
			fabricObject.canvas?.requestRenderAll();
		};
		// Draw a fallback (optional)
		ctx.save();
		ctx.translate(left, top);
		ctx.fillStyle = 'rgba(0,0,0,0.3)';
		ctx.fillRect(-size / 2, -size / 2, size, size);
		ctx.restore();
	}
};

export const getCurrentPrice = (commercialOptions: any) => {
	const now = new Date();
	const validFrom = new Date(commercialOptions?.validFrom);
	const validTo = new Date(commercialOptions?.validTo);

	// Check if current date is within the valid date range
	if (now >= validFrom && now <= validTo) {
		// Check if there is a sale price and it's not "0.00"
		if (commercialOptions?.salePrice && commercialOptions?.salePrice !== '0.00') {
			return commercialOptions?.salePrice;
		}
	}
	return commercialOptions?.price;
};
export const FAKE_SYMBOLS = [
	'https://files.upstrivesystem.com/public/bells.svg',
	'https://files.upstrivesystem.com/public/candy.svg',
	'https://files.upstrivesystem.com/public/christmas-decorations-for-trees-1.svg',
	'https://files.upstrivesystem.com/public/christmas-decorations-for-trees.svg',
	'https://files.upstrivesystem.com/public/christmas-deer-1.svg',
	'https://files.upstrivesystem.com/public/christmas-deer.svg',
	'https://files.upstrivesystem.com/public/christmas-bird.svg',
	'https://files.upstrivesystem.com/public/christmas-candy.svg',
];
export const VIRTUAL_CANVAS_SIZE = 500;
export const INITIAL_SCALE_FACTOR = 1.1;
export const LINE_CONFIGURATION = {
	stroke: 'rgba(255, 255, 255, 1)',
	strokeWidth: 3,
	selectable: false,
	hoverCursor: 'default',
	moveCursor: 'default',
	name: 'restriction_area',
};

export const productTypeLabelConverter: any = {
	newYear: 'New Year',
	bar: 'Bar',
	office: 'Office',
	wallDecor: 'Wall Decor',
	home: 'Home',
	kitchen: 'Kitchen',
	clothes: 'Clothes',
	baby: 'Baby',
	giftIdeas: 'Gift Ideas',
};
export const MerchantID = '216670995315FFD';
export const TerminalID = '5315001D';
export const CurrencyID = 941;
